import defaultConfig from './default-config';

export const config = {
  default: defaultConfig,
};
